import { render, staticRenderFns } from "./BrandDetailsIcon.vue?vue&type=template&id=fbb8f3a8&"
import script from "./BrandDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./BrandDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports